"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightRuleInvolvementType = exports.DashboardInsightInvolvementType = exports.DashboardNotificationChannel = void 0;
var DashboardNotificationChannel;
(function (DashboardNotificationChannel) {
    DashboardNotificationChannel["Email"] = "EMAIL";
    DashboardNotificationChannel["Slack"] = "SLACK";
    DashboardNotificationChannel["API"] = "API";
})(DashboardNotificationChannel = exports.DashboardNotificationChannel || (exports.DashboardNotificationChannel = {}));
var DashboardInsightInvolvementType;
(function (DashboardInsightInvolvementType) {
    DashboardInsightInvolvementType["ActiveDeveloper"] = "ACTIVE_DEVELOPER";
    DashboardInsightInvolvementType["TeamLead"] = "TEAM_LEAD";
    DashboardInsightInvolvementType["ProductManager"] = "PRODUCT_MANAGER";
    DashboardInsightInvolvementType["TaskReporter"] = "TASK_REPORTER";
    DashboardInsightInvolvementType["Committer"] = "COMMITTER";
    DashboardInsightInvolvementType["PullRequestCreator"] = "PULL_REQUEST_CREATOR";
    DashboardInsightInvolvementType["TaskUpdater"] = "TASK_UPDATER";
})(DashboardInsightInvolvementType = exports.DashboardInsightInvolvementType || (exports.DashboardInsightInvolvementType = {}));
var DashboardInsightRuleInvolvementType;
(function (DashboardInsightRuleInvolvementType) {
    DashboardInsightRuleInvolvementType["Default"] = "Default";
    DashboardInsightRuleInvolvementType["Custom"] = "Custom";
})(DashboardInsightRuleInvolvementType = exports.DashboardInsightRuleInvolvementType || (exports.DashboardInsightRuleInvolvementType = {}));
//# sourceMappingURL=dashboard-insight-rule-involvement.js.map